import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function CategorySection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">
            内容分类
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-md mx-auto">
            按照你的兴趣浏览不同类别的内容
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {categories.map((cat, i) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className={`group flex flex-col items-center gap-3 p-5 md:p-6 rounded-lg bg-background-50 hover:bg-primary-50 transition-all duration-300 cursor-pointer animate-fade-in-up`}
              style={{ animationDelay: `${i * 0.08}s` }}
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${cat.icon} text-xl md:text-2xl`}></i>
              </div>
              <span className="text-sm md:text-base font-medium text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}